module.exports = __webpack_public_path__ + "static/media/kids_20.04540ab0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_20.jpg
// module id = 5876
// module chunks = 0